import React from "react";
import Header from "../layout/Header";
import Footer from "../layout/Footer";

const CONTACT_EMAIL = "info@dhawanacademy.com";

const Contact = () => {
  return (
    <div id="page" style={{ height: "100vh", display: "flex", flexDirection: "column", background: "#f0f0f0" }}>
      <Header />
      <Footer />

      <div className="page-content header-clear-medium" style={{ flex: 1, padding: "0 15px" }}>
        <div className="container" style={{ display: "flex", flexDirection: "column", justifyContent: "center", minHeight: "100%" }}>
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6">
              <div style={{
                background: "white",
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                padding: "30px 25px",
                textAlign: "center"
              }}>
                <div style={{
                  width: "70px",
                  height: "70px",
                  borderRadius: "50%",
                  background: "#f8f9fa",
                  border: "1px solid #e9ecef",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 16px"
                }}>
                  <i className="fa fa-envelope" style={{ fontSize: "28px", color: "#38a169" }}></i>
                </div>

                <h2 style={{
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "#333",
                  marginBottom: "6px"
                }}>
                  Contact Us
                </h2>

                <p style={{
                  fontSize: "14px",
                  color: "#666",
                  marginBottom: "20px"
                }}>
                  For queries, feedback, or support, please reach out to us by email.
                </p>

                <div style={{
                  background: "#f8f9fa",
                  borderRadius: "10px",
                  border: "1px solid #e9ecef",
                  padding: "16px 18px",
                  marginBottom: "18px"
                }}>
                  <div style={{ fontSize: "12px", color: "#888", marginBottom: "4px", letterSpacing: "0.5px" }}>
                    EMAIL
                  </div>
                  <a
                    href={`mailto:${CONTACT_EMAIL}`}
                    style={{
                      fontSize: "16px",
                      fontWeight: 700,
                      color: "#38a169",
                      wordBreak: "break-all",
                      textDecoration: "none"
                    }}
                  >
                    {CONTACT_EMAIL}
                  </a>
                </div>

                <a
                  href={`mailto:${CONTACT_EMAIL}`}
                  className="btn btn-m rounded-l btn-full bg-green-dark font-900 text-uppercase"
                  style={{ width: "100%", display: "block" }}
                >
                  Send Email
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
